export default __webpack_public_path__ + "maps-examples-offline-storage-thumbnail-960-559cb1ea747f5cbe118ad49b3c1d289a.png";